<style lang="scss" scoped>
@import "core";

.dn-progress-bar {
  width: 100%;
  height: 10px;
  font-size: inherit;
  background: $color-divider;
  position: relative;

  &__inner {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background: $color-primary;
    transition: width .25s;
  }
}
</style>



<template>
<div :class="classes">
  <div class="dn-progress-bar__inner" :style="innerStyle"></div>
</div>
</template>



<script>



export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },



  data() {
    return {
    }
  },



  computed: {
    classes() {
      return {
        'dn-progress-bar': true,
      }
    },

    innerStyle() {
      return {
        width: `${Number((Math.min(this.value, 1) * 100).toFixed(2))}%`,
      }
    },
  },
}
</script>


// WEBPACK FOOTER //
// ProgressBar.vue?283679b8